import { c as _c } from "react/compiler-runtime";
import { LinkTab, Tabs } from '@/components/navigation/NavigationTabs';
import { ROUTE_KEYS } from '@/navigation/constants';
import { getCompletePathFromRouteKey } from '@/navigation/navigationUtils';
export const AI_PROMPTS_DESCRIPTION = 'Create and edit prompts for features such as document summaries and reviews.';
export function AdminAiPromptsNavigation() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LinkTab to={getCompletePathFromRouteKey(ROUTE_KEYS.ADMIN_SUMMARY_PROMPTS, {})} display="Document summaries" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Tabs>{t0}<LinkTab to={getCompletePathFromRouteKey(ROUTE_KEYS.ADMIN_FORMS, {})} display="Reviews" /></Tabs>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}